<template>
  <v-combobox
    v-model="selectedValue"
    :items="specialties"
    :hide-no-data="!search"
    :search-input.sync="search"
    small-chips
    outlined
    dense
    :label="labelText" 
    @input="event => { $emit('input', event) }"
  >
        <template slot="no-data">
          <v-list-item>
            <span class="subheading">{{ $t('message.click_enter_add_new') }}: </span>
            <v-chip
              label
              small
            >
              {{ search }}
            </v-chip>
          </v-list-item>
        </template>
  </v-combobox>
</template>

<script>
import UserService from "@/services/UserService";

export default {
  data() {
    return {
      selectedValue: null,
      specialties: [],
      loading: false,
      items: [],
      search: null,
      labelText: null,
    };
  },
  created() {
    if(this.label)
      this.labelText = this.label;
    UserService.specialties()
      .then(data => {
        if (data) {
          this.specialties = data.sort();
        }
      });
  },
  mounted(){
    this.selectedValue = this.value
  },
  props: {
    value: null,
    label: null
  },
  watch: {
    search(val) {
      val && this.querySelections(val);
    },
    value: {
      handler: function(newValue) {
        this.selectedValue = newValue;
        this.$emit("input", newValue);
      }
    }
  },
  methods: {
    async querySelections(v) {
      this.loading = true;
      if (this.specialties && this.specialties.length == 0) {
        var data = await UserService.specialties();
        this.specialties = data.sort();
      }
      this.items = this.specialties.filter(e => {
        return (e || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1;
      });
      this.loading = false;
    }
  }
};
</script>

<style scoped>
</style>
